export const SET_USER = "AUTH/SET_USER";
export const SET_TOKEN = "AUTH/SET_TOKEN";
export const SET_EMPRESA = "AUTH/SET_EMPRESA";
export const SET_MANTEM_CONECTADO = "AUTH/SET_MANTEM_CONECTADO";